import React, { ForwardedRef, forwardRef } from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import Button from "..";
import css from "../Button.module.scss";

export interface IconButtonProps {
	/**
	 * A font awesome icon to render in the button
	 */
	icon?: string | IconDefinition;
	/**
	 * A function to call when the button is clicked
	 */
	onClick?: (_e?: Event) => void;
	/**
	 * A link to navigate to when the button is clicked
	 */
	href?: string;
	/**
	 * if we want to render a disabled button
	 * @default false
	 */
	disabled?: boolean;
	/**
	 * Any additional classes to apply to the button
	 */
	className?: string;
	/**
	 * The color of the button
	 * @default blue
	 */
	color?: "blue" | "green" | "red" | "gray";
	/**
	 * if we want to render a button wiht an animation on click (active state)
	 * @default false
	 */
	animated?: boolean;
	/**
	 * if we want to render a button with a spinner
	 * @default false
	 */
	isRequesting?: boolean;
	square?: boolean;
	activated?: boolean;
	testId?: string;
	isHollow?: boolean;

	style?: object;
	children?: React.ReactNode;
	iconOnly?: boolean;

	/**
	 * The size of the button
	 */
	size?: "large" | "medium" | "small" | "micro";
}

/**
 * @deprecated Use the ButtonIcon component from the py-components package instead
 */
const IconButton = forwardRef(
	(
		{
			icon,
			onClick,
			href,
			disabled = false,
			className = "",
			color = "gray",
			animated = false,
			isRequesting = false,
			square = false,
			testId,
			children = null,
			activated = false,
			isHollow = false,
			iconOnly = false,
			style,
			size,
		}: IconButtonProps,
		ref: ForwardedRef<HTMLButtonElement>
	) => {
		return (
			<Button
				ref={ref}
				testid={testId}
				onClick={onClick}
				href={href}
				disabled={disabled}
				className={` ${css.icon} ${iconOnly ? css.iconOnly : ""} ${animated ? css.animated : ""} ${square ? "" : css.circle} ${activated ? css.activated : ""} ${className} `}
				icon={icon}
				color={color}
				isRequesting={isRequesting}
				isHollow={isHollow}
				style={style}
				size={size}
			>
				{children}
			</Button>
		);
	}
);
IconButton.displayName = "IconButton";

export default IconButton;
